export const pkg = {
  name: 'isomorphic-git',
  version: '1.31.1',
  agent: 'git/isomorphic-git@1.31.1',
}
